
import { Options } from "vue-class-component";
import Base from "./../base/Base.vue";
import LayoutService from "../../services/layout.service";
import { ChallengeType } from "@/enum/challenge.type";
import { ScreenType } from "@/enum/screen.type";
@Options({})
export default class LeftHall extends Base {
  openCreateChallenger() {
    this.redirectTo(ScreenType.setupChallenge);
    LayoutService.setStateSidebarLeft(false);
  }

  selectChallenge(challengeType: ChallengeType) {
    this.redirectTo(ScreenType.setupChallenge, "challengeType", challengeType);
  }
}
